<template>
  <el-table-column
    prop="second_copy_receive_date"
    sortable="custom"
    label="Második másolat beérk."
  >
    <template slot-scope="scope">
      {{ scope.row.second_copy_receive_date }} <span v-if="scope.row.second_copy_creator_user_name">({{ scope.row.second_copy_creator_user_name }})</span>
    </template>
  </el-table-column>
</template>

<script>
export default {
  propName: 'representativeUser.last_name',
};
</script>
